// Mapa rota -> meta de SEO (title 50-60 chars, description 150-160 chars).
// Usado por <RouteSeo/> em App.js, sem precisar editar cada página.
export const SEO_META = {
  "/": {
    title: "QA Iniciante | Comece em QA com mentoria e ferramentas",
    description:
      "Comece em QA com clareza: mentoria com QA Engineer, ferramentas com IA, roadmap de carreira e materiais para conseguir sua primeira vaga em testes de software.",
  },
  "/assinaturas": {
    title: "Planos e assinaturas | QA Iniciante Gratuito, Starter e PRO",
    description:
      "Compare os planos do QA Iniciante: gratuito, Starter e PRO. Veja o que cada um inclui em ferramentas, e-books e materiais para estudar e evoluir em QA.",
  },
  "/mentoria": {
    title: "Mentoria de QA para iniciantes | QA Iniciante com Rogério",
    description:
      "Mentoria individual de QA com Rogério Jordão, QA Engineer: plano de estudos, revisão de currículo e orientação prática para conquistar sua vaga em testes.",
  },
  "/revisao-curriculo": {
    title: "Revisão de currículo para QA com QA Engineer | QA Iniciante",
    description:
      "Receba uma revisão de currículo feita por um QA Engineer, com ajustes de escrita, estrutura e destaque de habilidades para vagas de QA e testes de software.",
  },
  "/ebooks": {
    title: "E-books do QA Iniciante para aprender testes de software",
    description:
      "Conheça os e-books do QA Iniciante para aprender testes de software: conceitos, prática e materiais de apoio para quem está começando na carreira de QA.",
  },
  "/sobre": {
    title: "Sobre o QA Iniciante e Rogério Jordão | QA Engineer e Mentor",
    description:
      "Conheça o QA Iniciante e Rogério Jordão, QA Engineer e mentor com ISTQB CTFL e experiência em AWS, que ajuda iniciantes a entrar na área de qualidade.",
  },
  "/faq": {
    title: "Perguntas frequentes sobre planos e mentoria | QA Iniciante",
    description:
      "Tire suas dúvidas sobre o QA Iniciante: planos, conta gratuita, mentoria, acesso aos e-books e ferramentas, e qual plano faz mais sentido para começar em QA.",
  },
  "/beneficios": {
    title: "Benefícios de estudar com o QA Iniciante | Comunidade de QA",
    description:
      "Veja os benefícios de fazer parte do QA Iniciante: ferramentas práticas, materiais, comunidade e apoio de um QA Engineer para acelerar sua entrada na área.",
  },
  "/mapa-de-carreira-qa": {
    title: "Roadmap de QA: carreira passo a passo | QA Iniciante",
    description:
      "Roadmap de carreira em QA passo a passo: o que estudar em testes manuais, automação, API, SQL e ferramentas para sair do zero e chegar à primeira vaga.",
  },
  "/quality-gate": {
    title: "Quality Gate de BDD e Gherkin gratuito | QA Iniciante",
    description:
      "Ferramenta gratuita para revisar cenários BDD em Gherkin: verifique critérios de aceite, clareza e cobertura antes de levar a história para desenvolvimento.",
  },
  "/template-bug": {
    title: "Template de bug report para QA: modelo pronto | QA Iniciante",
    description:
      "Use um template de bug report pronto para registrar defeitos com clareza: passos para reproduzir, resultado esperado e obtido, evidências e severidade.",
  },
  "/planner-qa": {
    title: "Planner QA: plano de estudos e testes com IA | QA Iniciante",
    description:
      "Monte seu plano de estudos e de testes com o Planner QA do QA Iniciante: organize prioridades, etapas e próximos passos para evoluir na carreira de qualidade.",
  },
  "/workspace-qa": {
    title: "Workspace QA: ferramentas de QA num só lugar | QA Iniciante",
    description:
      "Workspace QA reúne ferramentas práticas para o dia a dia de testes de software: organize casos de teste, bugs e estudos em um só lugar e ganhe produtividade.",
  },
  "/posts": {
    title: "Artigos sobre QA e testes de software | QA Iniciante",
    description:
      "Artigos do QA Iniciante sobre testes de software, carreira em QA, automação e boas práticas para quem quer começar ou evoluir na área de qualidade de software.",
  },
};

// Rotas que não devem ser indexadas (páginas privadas, transacionais ou admin).
const NOINDEX_EXACT = new Set([
  "/login",
  "/signup",
  "/confirmacao",
  "/agendamento",
  "/agendamento-confirmado",
  "/perfil",
  "/profile",
  "/whatsapp",
  "/posts/admin",
  "/artigos/admin",
]);

export function isNoindexPath(pathname) {
  if (NOINDEX_EXACT.has(pathname)) return true;
  return pathname.startsWith("/produtos") || pathname.startsWith("/biblioteca");
}

export function normalizePathname(pathname = "/") {
  const trimmed = pathname.replace(/\/+$/, "");
  return trimmed === "" ? "/" : trimmed;
}
